<template>
	<v-app>
		<v-navigation-drawer app v-model="drawer" enable-resize-watcher :permanent="$vuetify.breakpoint.mdAndUp">
		<v-app-bar color="primary" dark>
			<v-toolbar-title><img id="logo" style="height:40px;padding:auto;margin-top:8px;" src="./assets/logo.svg" alt="AVENUE - Logo" /></v-toolbar-title>
		</v-app-bar>
			<v-list nav dense>
				<v-list-item-group v-model="group" color="primary" mandatory>
					<v-list-item dense router to="/">
						<v-list-item-icon><v-icon>mdi-home</v-icon></v-list-item-icon>
						<v-list-item-content>Home</v-list-item-content>
					</v-list-item>
					<v-list-item dense router to="/arbeitsverdichtung">
						<v-list-item-icon><v-icon>mdi-information</v-icon></v-list-item-icon>
						<v-list-item-content>Arbeitsverdichtung</v-list-item-content>
					</v-list-item>
					<v-list-item dense router to="/box">
						<v-list-item-icon><v-icon>mdi-tools</v-icon></v-list-item-icon>
						<v-list-item-content>Verfahrensbox</v-list-item-content>
					</v-list-item>
					<v-list-item dense router to="/ressourcen">
						<v-list-item-icon><v-icon>mdi-folder-download</v-icon></v-list-item-icon>
						<v-list-item-content>Ressourcen</v-list-item-content>
					</v-list-item>
					<!--
					<v-list-item dense router to="/interview" v-if="(teilnehmer!='')">
						<v-list-item-icon><v-icon>mdi-clipboard-edit</v-icon></v-list-item-icon>
						<v-list-item-content>Interview</v-list-item-content>
						<v-list-item-icon><v-icon>mdi-account</v-icon></v-list-item-icon>
					</v-list-item>
					<v-list-item dense router to="/chatbot" v-if="(teilnehmer!='')">
						<v-list-item-icon><v-icon>mdi-chat</v-icon></v-list-item-icon>
						<v-list-item-content>Chatbot</v-list-item-content>
						<v-list-item-icon><v-icon>mdi-account</v-icon></v-list-item-icon>
					</v-list-item> 
					-->
					<v-list-item dense router to="/fragebogen">
						<v-list-item-icon>
							<v-icon v-if="(teilnehmer!='')">mdi-clipboard-text</v-icon>
							<v-icon v-else color="#aaaaaa">mdi-clipboard-text</v-icon>
						</v-list-item-icon>
						<v-list-item-content v-if="(teilnehmer!='')">Fragebogen</v-list-item-content>
						<v-list-item-content style="color:#aaaaaa;" v-else>Fragebogen</v-list-item-content>
						<v-list-item-icon>
							<v-icon v-if="(teilnehmer!='')" color="#055d05">mdi-account-lock-open</v-icon>
							<v-icon v-else color="#aaaaaa">mdi-account-lock</v-icon>
						</v-list-item-icon>
					</v-list-item>
					<v-list-item dense router to="/auswertung">
						<v-list-item-icon>
							<v-icon v-if="(teilnehmer!='')">mdi-chart-line-variant</v-icon>
							<v-icon v-else color="#aaaaaa">mdi-chart-line-variant</v-icon>
						</v-list-item-icon>
						<v-list-item-content v-if="(teilnehmer!='')">Auswertung</v-list-item-content>
						<v-list-item-content style="color:#aaaaaa;" v-else>Auswertung</v-list-item-content>						
						<v-list-item-icon>
							<v-icon v-if="(teilnehmer!='')" color="#055d05">mdi-account-lock-open</v-icon>
							<v-icon v-else color="#aaaaaa">mdi-account-lock</v-icon>
						</v-list-item-icon>
					</v-list-item>
					<!-- <v-list-item v-for="(item1, itemx1) in navigation1" :key="itemx1" dense router :to="item1.route">
						<v-list-item-icon>
							<v-icon>{{ item1.icon }}</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							{{ item1.title }}
						</v-list-item-content>
						<v-list-item-icon v-if="(item1.anmeldung == 1)">
							<v-icon>mdi-account</v-icon>
						</v-list-item-icon>
					</v-list-item>
					<v-list-item v-for="(item2, itemx2) in navigation2" :key="itemx2" dense router :to="item2.route">
						<v-list-item-icon>
							<v-icon>{{ item2.icon }}</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							{{ item2.title }}
						</v-list-item-content>
						<v-list-item-icon v-if="(item2.anmeldung == 1)">
							<v-icon>mdi-account</v-icon>
						</v-list-item-icon>
					</v-list-item>
					<v-list-item v-for="(item3, itemx3) in navigation3" :key="itemx3" dense router :to="item3.route">
						<v-list-item-icon>
							<v-icon>{{ item3.icon }}</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							{{ item3.title }}
						</v-list-item-content>
						<v-list-item-icon v-if="(item3.anmeldung == 1)">
							<v-icon>mdi-account</v-icon>
						</v-list-item-icon>
					</v-list-item> -->
				</v-list-item-group>
			</v-list>
		</v-navigation-drawer>
		<v-app-bar app color="primary" dark>
			<v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="!$vuetify.breakpoint.mdAndUp"></v-app-bar-nav-icon>
			<v-toolbar-title>{{ $route.name }}</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-toolbar-title style="margin-right:0.5em;">{{teilnehmer}}</v-toolbar-title>
			<v-menu left bottom v-if="(teilnehmer!='') && (lesezeichenAnzahl >= 1)">
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon v-bind="attrs" v-on="on">
						<v-badge color="red" :content="lesezeichenAnzahl">
							<v-icon>mdi-bookmark-multiple</v-icon>
						</v-badge>
					</v-btn>
				</template>
				<v-list>
					<v-list-item v-for="(lesezeichen, lesezeichenx) in lesezeichenTitelListe" :key="lesezeichenx" @click="lesezeichenAnzeigen(lesezeichen.verfahrenid)">
						{{lesezeichen.titel}}
					</v-list-item>
				</v-list>
			</v-menu>
			<v-menu left bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon v-bind="attrs" v-on="on">
						<v-icon v-if="teilnehmer!=''">mdi-account</v-icon>
						<v-icon v-else>mdi-dots-vertical</v-icon>
					</v-btn>
				</template>
				<v-list>
					<v-list-item v-if="teilnehmer==''" router to="/registrierung">Registrierung</v-list-item>
					<v-list-item v-if="teilnehmer==''" router to="/anmeldung">Anmeldung</v-list-item>
					<merkzettel v-if="teilnehmer!=''"></merkzettel>
					<!-- <v-list-item v-if="teilnehmer!=''" router to="/profil">Profil</v-list-item> -->
					<v-list-item v-if="teilnehmer!=''" @click="resetTeilnehmer()">Abmeldung</v-list-item>
				</v-list>
			</v-menu>
		</v-app-bar>
		<v-main>
			<v-container fluid>
				<router-view :key="$route.fullPath"></router-view>
			</v-container>
		</v-main>
		<v-footer app color="primary" padless>
			<v-row justify="center" no-gutters>
				<v-btn x-small v-for="(link, linkx) in links" :key="linkx" color="white" text rounded class="my-2" router :to="link.route">{{ link.title }}</v-btn>
			</v-row>
		</v-footer>
	</v-app>
</template>
<script>
	import axios from 'axios';
	import merkzettel from './components/merkzettel.vue'
	export default {
		name: 'App',
		components: {
			merkzettel
		},
		data: () => ({
			drawer: false,
			group: null,
			navigation1: [
				{anmeldung: '0', icon: 'mdi-home', title:'Home', route:'/'},
				{anmeldung: '0', icon: 'mdi-information', title:'Arbeitsverdichtung', route:'/arbeitsverdichtung'},
				{anmeldung: '1', icon: 'mdi-clipboard-edit', title:'Interview', route:'/interview'},
				{anmeldung: '1', icon: 'mdi-chat', title:'Chatbot', route:'/chatbot'},
				{anmeldung: '1', icon: 'mdi-clipboard-text', title:'Fragebogen', route:'/fragebogen'},				
				{anmeldung: '1', icon: 'mdi-chart-line-variant', title:'Auswertung', route:'/auswertung'},
				{anmeldung: '0', icon: 'mdi-tools', title:'Verfahrensbox', route:'/box'},
				{anmeldung: '0', icon: 'mdi-information', title:'Projekt', route:'/projekt'},
				{anmeldung: '0', icon: 'mdi-bullseye-arrow', title:'Ergebnisse', route:'/ergebnisse'},				
				{anmeldung: '0', icon: 'mdi-file-document-multiple', title:'Veröffentlichungen', route:'/veroeffentlichungen'},
				{anmeldung: '0', icon: 'mdi-contacts', title:'Kontakt', route:'/kontakt'},
				{anmeldung: '0', icon: 'mdi-help', title:'Hilfe', route:'/hilfe'}
			],
			navigation2: [
			],
			navigation3: [
			],				
			links: [
				{title:'Home', route:'/'},
				{title:'Kontakt', route:'/kontakt'},
				{title:'Impressum', route:'/impressum'},
				{title:'Datenschutz', route:'/datenschutz'}
			],
			menue: [
				{title:'Registrierung', route:'/registrierung'},
				{title:'Anmeldung', route:'/anmeldung'},
				// {title:'Abmeldung', route:'/abmeldung'}
			],
			gruppe: String
		}),
		methods: {
			setTeilnehmer(kennung) {
				this.$store.dispatch('setTeilnehmer', kennung);
				this.$router.push({name: 'Home'});
			},
			resetTeilnehmer() {
				this.$store.dispatch('resetTeilnehmer');
				this.$router.push({name: 'Home'});
			},
			getLesezeichenListe() {
				this.$store.dispatch('getLesezeichenListe');
			},
			lesezeichenAnzeigen(verfahrenid) {
				console.log(verfahrenid);
				this.$router.push({name: 'Verfahren', params: {verfahrenid: verfahrenid}});
			},
			async anmeldungTeilnehmer(kennung) {
				try {
					const response = await axios.get('https://www.arbeitsverdichtung.de/api/kennung', {
						params: {
							kennung: kennung
						}
					});
					if (Number.parseInt(response.data) == 1) {
						this.setTeilnehmer(kennung);
						this.getLesezeichenListe();
					} else {
						this.fehlermeldung = 'Die Anmeldung war nicht erfolgreich! Die Kennung ist auf der Plattform nicht bekannt.';
						setTimeout(() => {
							this.fehlermeldung = '';
						}, 5000)
					}
				} catch (error) {
					alert(error);
				}
			},
		},
		mounted() {
			console.log('App mounted!');
			/* Bestehender Teilnehmer wird angemeldet */
			if (localStorage.getItem('teilnehmer')) {
				this.setTeilnehmer(localStorage.getItem('teilnehmer'));
				this.getLesezeichenListe();
			}
			/* Falls ein Fragebogen gesetzt, ist dann werden die angeforderten Seiten weitergereicht */
			console.log('Query string');
			console.log(this.$route.query);
			/* Falle ein query string übergeben wurde, dann wird er Paramenter fr parameter abgearbeitet */
			if (this.$route.query) {
				/* Anmeldung des Teilnehmenden über den query string*/
				if (this.$route.query.a) {
					console.log('Parameter a: ' + this.$route.query.a);
					this.anmeldungTeilnehmer(this.$route.query.a);
				}
				/* Aufruf eines Fragebogens */
				if (this.$route.query.e) {
					console.log('Parameter e: ' + this.$route.query.e);
					// Falls der Teilnehmende bereits angemeldet ist, erfolgt eine Weiterleitung zum Fragebogen
					if (this.teilnehmer!='') {
						this.$router.push({
							path: '/fragebogen', 
							query: {
								e: this.$route.query.e, 
								b: this.$route.query.b
							}
						});
					} 
					// Andernfalls erfolgt eine Weiterleitung zur Registierung mit Übergabe des Parameters e anhand dem erkannt werden soll, dass ene Fragebogen bearbeitet werden soll
					else {
						this.$router.push({
							path: '/registrierung', 
							query: {
								e: this.$route.query.e, 
								b: this.$route.query.b
							}
						});
					}
				}
			}
		},
		computed: {
			teilnehmer: function() {
				return this.$store.state.teilnehmer;
			},
			lesezeichenTitelListe: function() {
				return this.$store.state.lesezeichenTitelListe;
			},
			lesezeichenAnzahl: function() {
				var lesezeichenAnzahl = this.$store.state.lesezeichenListe.length;
				return lesezeichenAnzahl;
			}
		},
		watch: {
			group () {
				this.drawer = false
			}
		}
	}
</script>
<style>
	h1 {
		font-size: 1.5em;
		margin-top: 0.5em;
		margin-bottom: 0.5em;
		}
	h2 {
		font-size: 1.25em;
		margin-top: 1.25em;
		margin-bottom: 0.25em;
		}
	h3 {
		font-size: 1em;
		margin-top: 1em;
		margin-bottom: 0.5em;
	}
	ul {
		margin-bottom: 1em;
	}	
</style>
